// hooks/useInvitationsQuery.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import drEasyApi from '../Api/Customapi';

// Hook to fetch all invitations
export const useInvitations = () => {
  return useQuery({
    queryKey: ['invitations'],
    queryFn: async () => {
      const response = await drEasyApi.get('/api/Invitations/getMyInvitations');
      return response.data;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
    refetchOnWindowFocus: true, // Refetch when window regains focus
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};

// Hook to get pending invitations count
export const usePendingInvitationsCount = () => {
  return useQuery({
    queryKey: ['invitations', 'pendingCount'],
    queryFn: async () => {
      const response = await drEasyApi.get('/api/Invitations/getMyInvitations');
      const pendingInvitations = response.data.filter(inv => inv.status === 'Pending');
      return pendingInvitations.length;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
    refetchOnWindowFocus: true,
    staleTime: 10000,
  });
};

// Hook to respond to invitations
export const useRespondToInvitation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ invitationId, accept }) => {
      const response = await drEasyApi.put("/api/Invitations/RespondToInvitation", {
        invitationId,
        accept
      });
      return response.data;
    },
    onSettled: () => {
      // Invalidate and refetch invitation queries after responding
      queryClient.invalidateQueries({ queryKey: ['invitations'] });
    },
    onSuccess: (data, variables) => {
      console.log(`Invitation ${variables.accept ? 'accepted' : 'declined'} successfully`);
    },
    onError: (error) => {
      console.error('Error responding to invitation:', error);
    }
  });
};